// API Configuration
export const API_CONFIG = {
	production: {
		baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.alertpanel.io',
		timeout: 30000, // Increased to 30s for test environment with slow queries
		retries: 3
	},
	development: {
		baseURL: import.meta.env.VITE_DEV_API_BASE_URL || 'https://localhost:5001',
		timeout: 5000,
		retries: 1
	}
};

// Get current environment configuration
const getCurrentConfig = () => {
	const isDevelopment = import.meta.env.DEV;
	if (!isDevelopment && !import.meta.env.VITE_API_BASE_URL) {
		console.error(
			'[env] VITE_API_BASE_URL is not set. API calls and SignalR will fail. ' +
			'Set this environment variable at build time.'
		);
	}
	return isDevelopment ? API_CONFIG.development : API_CONFIG.production;
};

export const currentApiConfig = getCurrentConfig();

// Legacy exports for backward compatibility
export const env = API_CONFIG.production.baseURL;
export const devEnv = API_CONFIG.development.baseURL;
